export const PRINT_FONT_SIZE_MIN = 10
export const PRINT_FONT_SIZE_MAX = 22
export const DEFAULT_CUSTOMER_RECEIPT_FONT_SIZE = 12
export const DEFAULT_KITCHEN_TICKET_FONT_SIZE = 13

/** Extra scale for thermal/silent print readability (HTML → PDF → receipt printer). */
export const THERMAL_READABILITY_SCALE = 0.95

const RECEIPT_CSS_BASE = 12
const KITCHEN_CSS_BASE = 13

export type PrintFontKind = 'customer' | 'kitchen'

function defaultFor(kind: PrintFontKind): number {
 return kind === 'kitchen' ? DEFAULT_KITCHEN_TICKET_FONT_SIZE : DEFAULT_CUSTOMER_RECEIPT_FONT_SIZE
}

/** Clamp branch/POS font size to a safe integer px value for print HTML. */
export function clampPrintFontSize(value: unknown, kind: PrintFontKind = 'customer'): number {
 const fallback = defaultFor(kind)
 if (value === undefined || value === null || value === '') return fallback
 const n = typeof value === 'number' ? value : parseInt(String(value), 10)
 if (!Number.isFinite(n)) return fallback
 return Math.max(PRINT_FONT_SIZE_MIN, Math.min(PRINT_FONT_SIZE_MAX, Math.round(n)))
}

/** Scale a CSS px size relative to the configured print font size (+ thermal readability). */
export function scaleReceiptCssPx(basePx: number, fontSizePx: number): number {
 const safe = clampPrintFontSize(fontSizePx, 'customer')
 return (
 Math.round((basePx * safe * THERMAL_READABILITY_SCALE) / RECEIPT_CSS_BASE * 10) / 10
 )
}

export function scaleKitchenCssPx(basePx: number, fontSizePx: number): number {
 const safe = clampPrintFontSize(fontSizePx, 'kitchen')
 return (
 Math.round((basePx * safe * THERMAL_READABILITY_SCALE) / KITCHEN_CSS_BASE * 10) / 10
 )
}

export function isPrintFontSizeInRange(value: number): boolean {
 return Number.isFinite(value) && value >= PRINT_FONT_SIZE_MIN && value <= PRINT_FONT_SIZE_MAX
}
